export default __webpack_public_path__ + "static/1031-195dfc05d2bc460f92ce609ef148519f.gif";